import React, {useState, useCallback} from 'react';
import _ from 'lodash';
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {Replacement} from '../../../../interface';
import localesReplacement from '../../../../utils/localesReplacement';

interface IQuickSearchInputProps {
  country: string | undefined;
  language: string | undefined;
  value: string;
  onChangeHandler: (value: string, token?: string) => void;
  onClearHandler: (value: React.MouseEvent) => void;
  licence: boolean;
  captcha: boolean;
  replacements: Replacement;
  onMouseDownHandler?: (value: string) => void;
}

const cx = classnames.bind(style);

function QuickSearchInput(props: IQuickSearchInputProps) {
  const {
    country,
    value,
    onChangeHandler,
    onClearHandler,
    licence,
    captcha,
    replacements,
    language,
    onMouseDownHandler,
  } = props;

  const [reCaptchaToken, setRecaptchaToken] = useState<string>('');

  const onVerify = useCallback((token: any): void => {
    setRecaptchaToken(token);
  }, []);

  return (
    <div className={cx('search-input', {withValue: !!value})}>
      <div className={cx('block')}>
        {value && <label>{localesReplacement(replacements, 'Search')}</label>}
        {!licence || _.isEqual(country, 'USA') || _.isEqual(country, 'AUS') ? (
          <input
            type='text'
            value={value}
            onChange={(ev) => onChangeHandler(ev.target.value)}
            placeholder={localesReplacement(
              replacements,
              _.includes(['AUS', 'NZL'], country)
                ? 'Quick search (e.g. Toyota Hilux 2020)'
                : 'Search by brand or model',
            )}
            onFocus={() => {
              onMouseDownHandler && onMouseDownHandler(value);
            }}
            maxLength={36}
          />
        ) : (
          <>
            {captcha && (
              <>
                <div
                  id='captcha-container'
                  className={cx('recaptcha-container')}
                ></div>
                <GoogleReCaptchaProvider
                  reCaptchaKey={
                    process.env.REACT_APP_RECAPCHA_SITEKEY ||
                    '6Ld2oX4UAAAAACqWA9-3ostCypVeQRd4JPIT6dZR'
                  }
                  language={language?.slice(0, -1).toLowerCase()}
                  useRecaptchaNet={false}
                  useEnterprise={false}
                  scriptProps={{
                    async: false, // optional, default to false,
                    defer: false, // optional, default to false
                    appendTo: 'head', // optional, default to "head", can be "head" or "body",
                    nonce: undefined, // optional, default undefined
                  }}
                  container={{
                    // optional to render inside custom element
                    element: 'captcha-container',
                    parameters: {
                      badge: 'inline', // optional, default undefined
                      theme: 'dark', // optional, default undefined
                    },
                  }}
                >
                  <GoogleReCaptcha onVerify={onVerify} />
                </GoogleReCaptchaProvider>
              </>
            )}
            <input
              type='text'
              value={value}
              onChange={(ev) =>
                captcha
                  ? onChangeHandler(ev.target.value, reCaptchaToken)
                  : onChangeHandler(ev.target.value)
              }
              placeholder={localesReplacement(
                replacements,
                'Search by license, brand or model',
              )}
              onFocus={() => {
                onMouseDownHandler && onMouseDownHandler(value);
              }}
              maxLength={36}
            />
          </>
        )}
      </div>

      {value.length ? (
        <i className={cx('remove')} onClick={onClearHandler}></i>
      ) : (
        <i className={cx('voice')}></i>
      )}
    </div>
  );
}

export default QuickSearchInput;
